import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/header-popup.png'


const _withScopeId = n => (_pushScopeId("data-v-08355de4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-headerr" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title text-center" }, [
    /*#__PURE__*/_createElementVNode("header", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "inline-block logo",
        alt: "Taykus logo",
        src: _imports_0
      })
    ])
  ])
], -1))
const _hoisted_2 = { class: "flex justify-center w-full mt-8 input-component" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  id: "loginError",
  class: "flex justify-center w-full mt-4"
}
const _hoisted_5 = { class: "form-error" }
const _hoisted_6 = { class: "relative w-full account-text cursor-pointer forgot" }
const _hoisted_7 = { class: "flex justify-center w-full mt-6" }
const _hoisted_8 = { class: "relative w-full account-text" }
const _hoisted_9 = { class: "flex justify-center w-full mt-8" }
const _hoisted_10 = { class: "relative w-3/6 float-right" }
const _hoisted_11 = { class: "relative w-3/6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputEmail = _resolveComponent("InputEmail")!
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_SvgContainer = _resolveComponent("SvgContainer")!
  const _component_CustomGoogleLogin = _resolveComponent("CustomGoogleLogin")!
  const _component_CustomAppleLogin = _resolveComponent("CustomAppleLogin")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_RecoverPassword = _resolveComponent("RecoverPassword")!
  const _component_PopupLight = _resolveComponent("PopupLight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.openLogin || _ctx.$store.state.loginIsOpen)
          ? (_openBlock(), _createBlock(_component_Popup, {
              key: 0,
              showOkButton: false,
              onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeLogin()))
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t("login")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("discover_your_places_in_the_world")), 1),
                _createElementVNode("form", {
                  onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_InputEmail, {
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_InputPassword, { onPasswordValidated: _ctx.handlePasswordValidated }, null, 8, ["onPasswordValidated"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("input", {
                      type: "submit",
                      value: "Login",
                      disabled: _ctx.hasErrors,
                      class: _normalizeClass({ 'button-disabled': _ctx.hasErrors, '': true })
                    }, null, 10, _hoisted_3)
                  ])
                ], 32),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.loginError), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openRecoverPsw && _ctx.openRecoverPsw(...args)))
                  }, _toDisplayString(_ctx.$t("forgot_password")), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_SvgContainer, { name: "loginLeftBar" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("or_create_account_with")), 1),
                    _createVNode(_component_SvgContainer, { name: "loginRightBar" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_CustomGoogleLogin, { onSuccess: _ctx.handleAppLoginSuccess }, null, 8, ["onSuccess"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_CustomAppleLogin, { onSuccess: _ctx.handleAppLoginSuccess }, null, 8, ["onSuccess"])
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showRegister())),
                  class: "walletButton mt-6 p-4 text-center cursor-pointer sm:text-sm"
                }, _toDisplayString(_ctx.$t("register")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.openRecover)
      ? (_openBlock(), _createBlock(_component_PopupLight, {
          key: 0,
          onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleCloseRecover()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RecoverPassword, {
              phase: _ctx.phase,
              token: _ctx.token,
              onCloseRecover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleCloseRecover()))
            }, null, 8, ["phase", "token"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}